"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdKey = getIdKey;
exports.getId = getId;
exports.getObjectType = getObjectType;
exports.getProperty = getProperty;
exports.getPropertyValue = getPropertyValue;

var _getIn = _interopRequireDefault(require("transmute/getIn"));

function getIdKey(record) {
  return record && record.constructor._idKey;
}

function getId(record) {
  return record && (0, _getIn.default)(getIdKey(record), record);
}

function getObjectType(record) {
  return record && record.constructor._objectType;
}

function getProperty(record, property) {
  return record && (0, _getIn.default)(['properties', property, 'value'], record);
}

function getPropertyValue(record, property) {
  return record && (0, _getIn.default)(['properties', property], record);
}